var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsipid(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3747 10.0001L15.5483 5.82646C15.9284 5.44633 15.9284 4.83189 15.5483 4.45176C15.1682 4.07163 14.5538 4.07163 14.1737 4.45176L10.0001 8.62543L5.82651 4.45176C5.44638 4.07163 4.83196 4.07163 4.45184 4.45176C4.07172 4.83189 4.07172 5.44633 4.45184 5.82646L8.62542 10.0001L4.45184 14.1738C4.07172 14.5539 4.07172 15.1683 4.45184 15.5485C4.64142 15.7381 4.89029 15.8333 5.13917 15.8333C5.38805 15.8333 5.63693 15.7381 5.82651 15.5485L10.0001 11.3748L14.1737 15.5485C14.3632 15.7381 14.6121 15.8333 14.861 15.8333C15.1099 15.8333 15.3587 15.7381 15.5483 15.5485C15.9284 15.1683 15.9284 14.5539 15.5483 14.1738L11.3747 10.0001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsipid);
export default __webpack_public_path__ + "static/media/insipid.350e4cf9f15d4911b0e92ca8392ef13f.svg";
export { ForwardRef as ReactComponent };